import { useEffect } from 'react';

interface Props {
  initForm(): void;
}

export const useAddProductEffects = ({ initForm }: Props) => {
  useEffect(() => {
    initForm();
  }, [initForm]);
};
